var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('NavigationDrawer'),_c('ToolBar'),_c('v-main',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":true}},[_c('v-layout',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.key})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }